---
title: 'Step 1: Determine Log Location'
install_track_title: 'Log Insights: Setup (Self-Managed)'
backlink_href: /docs/log-insights/setup
backlink_title: 'Log Insights: Setup'
---

import TabPanel, {Tab} from '../../../components/TabPanel'

import StandardInstructions from './_01_standard_instructions.mdx'
import InDataDirInstructions from './_01_in_data_dir_instructions.mdx'
import SyslogInstructions from './_01_syslog_instructions.mdx'

Log Insights works by continuously tailing your local Postgres log files, classifying log lines,
and submitting log data and statistics to pganalyze. The self-managed configuration requires
your collector to run on the same instance as your Postgres server.

**Note:** You can optionally have a syslog client sending logs to [the collector
syslog server](https://pganalyze.com/docs/log-insights/setup/syslog-server). When using Kubernetes,
you can also send logs to [the collector's OpenTelemetry HTTP endpoint](https://pganalyze.com/docs/log-insights/setup/opentelemetry).

You will need to configure the `db_log_location` in the `pganalyze-collector.conf` file, and set
it to either the filename of the Postgres log file, or the directory in which log files are located.

We provide a helper for discovering the log directory, which you must run as root or using sudo. Run
the command like this:

```bash
sudo pganalyze-collector --discover-log-location
```

This will then produce output like this:

```
2018/05/20 19:51:30 I [server1] Found log location, add this to your pganalyze-collector.conf in the [server1] section:
db_log_location = /var/log/postgresql/postgresql-9.3-main.log
```

Or alternately, you may get a warning, in which case some extra configuration is necessary. In some cases where discovery
doesn't work you might have to review in more detail how your system is set up. Please reach out to pganalyze support
for help if needed.

Otherwise, continue below according to the output:

<TabPanel>
  <Tab id="standard" label="Found log location" textContent>
    <StandardInstructions />
  </Tab>
  <Tab id="in_data_dir" label="Log location in data directory" textContent>
    <InDataDirInstructions />
  </Tab>
  <Tab id="syslog" label="Using syslog" textContent>
    <SyslogInstructions />
  </Tab>
</TabPanel>

<Link className="btn btn-success" to="02_configure_collector">
  Continue to Step 2: Configure collector
</Link>
